import { I18nUtils } from '../../../../i18n/I18nUtils';

export class MachineFormValidator {

    static validate(values) {
        const {
            licensePlate,
            brand,
            model,
            description,
        } = values;

        const errors = {};
        const emptyFieldError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

        if ( !licensePlate ) errors.licensePlate = emptyFieldError;
        if ( !brand ) errors.brand = emptyFieldError;
        if ( !model ) errors.model = emptyFieldError;
        if ( !description ) errors.description = emptyFieldError;

        return errors;
    };
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/MachineFormValidator.jsx